<template>
  <div v-if="setting.type === 'tag'">
    <span style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px" class="has-text-grey">
      {{ setting.label || name }}
    </span>
    <el-tag
      v-for="tag in value[name]"
      :key="tag"
      closable
      :disable-transitions="false"
      @close="handleRemoveTag(tag)"
    >
      {{ tag }}
    </el-tag>
    <el-input
      v-if="tagInputVisible"
      ref="saveTagInput"
      v-model="tagInputValue"
      class="input-new-tag"
      size="mini"
      @keyup.enter.native="handleAddTag"
      @blur="handleAddTag"
    />
    <el-button v-else class="button-new-tag" size="small" @click="showTagInput">
      + New Tag
    </el-button>
  </div>
</template>

<script>
/**
 * Tag SmartField - Renders a tag input for array of string configuration values.
 *
 * @component
 * @description Displays a list of tags with the ability to add new tags and remove existing ones.
 * Tags are displayed as closable chips. Users can click "+ New Tag" to add a new tag,
 * which can be confirmed by pressing Enter or blur.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the tag input (defaults to name)
 * @prop {string} setting.type - Must be 'tag' for this component to render
 * @prop {Array<string>} [setting.default] - Default array of tags if not set
 * @prop {string} name - Property key in the value object (should be an array)
 *
 * @example
 * <Tag
 *   :value="config"
 *   :setting="{ label: 'Keywords', type: 'tag', default: [] }"
 *   name="keywords"
 * />
 */
export default {
  props: ["value", "setting", "name"],
  data() {
    return {
      tagInputValue: "",
      tagInputVisible: false,
    };
  },
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
  methods: {
    /**
     * Shows the tag input field for adding a new tag.
     *
     * @return {void}
     */
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    /**
     * Removes a tag from the tags array.
     *
     * @param {string} tag - Tag to remove
     * @return {void}
     */
    handleRemoveTag(tag) {
      this.setting.tags.splice(this.setting.tags.indexOf(tag), 1);
    },
    /**
     * Adds a new tag to the tags array.
     *
     * @return {void}
     */
    handleAddTag() {
      let inputValue = this.tagInputValue;
      if (inputValue) {
        this.value[this.name].push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = "";
    },
  },
};
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
